import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '../Typography';
import { Button } from '../Button';
import { VideoDialog } from './index';
import componentStyles from './VideoButton-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import { getCdnImage } from "../../../utils/ImageManager"

class VideoButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_dialog: false,
    };
  }

  handleClick = event => {
    const { detachDialog, video, styleName, onClick } = this.props;
    if (detachDialog) {
      const dialog_object = {
        video: video.videoLink,
        dialogStyles: styleName.dialog,
      };

      onClick(dialog_object);
      event.preventDefault();
      return;
    }
    this.setState({ show_dialog: true });
    event.preventDefault();
  };

  handleClose = () => {
    this.setState({ show_dialog: false });
  };

  render() {
    const {
      className,
      buttonClassName,
      textClassName,
      buttonText,
      text,
      icon,
      video,
      alt,
      variant,
      component,
      styleName,
      detachDialog,
      ...other
    } = this.props;
    const { show_dialog } = this.state;
    let element = null;
    const videoThumbnail = video && video.videoThumbnail;
    const videoLink = video && video.videoLink;
    const styleNameContainer = styleName ? styleName.imageContainer : '';
    if (variant === i18nMessages.Image_Button) {
      element = videoThumbnail && videoThumbnail.url && (
        <Typography
          onClick={this.handleClick}
          data-action-detail={`${videoLink}`}
          component="div"
          className={`image_button cursor-pointer ${styleNameContainer}`}
        >
          <img
            className={styleName.image}
            alt={videoThumbnail.alt}
            src={getCdnImage(`${videoThumbnail.url}`)}
          />
          <span className={styleName.icon} />
        </Typography>
      );
    } else if (
      variant === i18nMessages.IconButton ||
      variant === 'Simple-Button'
    ) {
      element = (
        <Button
          onClick={this.handleClick}
          title={other.tooltip}
          className={classNames(styleName.button, 'event_video_play')}
          data-action-detail={`${videoLink}`}
        >
          {variant === i18nMessages.IconButton &&
            React.cloneElement(icon, {
              className: classNames(icon.props.className, styleName.icon),
            })}
          <span className={styleName.text}>{text || buttonText}</span>
        </Button>
      );
    }

    return (
      <div className={className}>
        <div className={styleName.buttonWrapper}>{element}</div>
        {show_dialog && !detachDialog && (
          <VideoDialog
            video={videoLink}
            handleClose={this.handleClose}
            styleName={styleName.dialog}
          />
        )}
      </div>
    );
  }
}

VideoButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  alt: PropTypes.string,
  /*
   * Video button variant [Icon-Button, Simple-Button, Image-Button]
   */
  variant: PropTypes.string,
  /*
   * Title to display
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /*
   * video icon
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.any]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  buttonClassName: PropTypes.string,

  /**
   * @ignore
   */
  textClassName: PropTypes.string,
  /**
   * @ignore
   */
  text: PropTypes.string,
  /**
   * @ignore
   */
  buttonText: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   *   video object that contains video link and video thumbnail
   */
  video: PropTypes.oneOfType([
    PropTypes.shape({
      videoLink: PropTypes.string,
      videoThumbnail: PropTypes.object,
      title: PropTypes.string,
      autoplay: PropTypes.bool,
      transcript: PropTypes.string,
      componentWidth: PropTypes.object,
      styles: PropTypes.string,
    }),
    PropTypes.object,
  ]),
  /**
   *   styleName set for complete component
   */
  styleName: PropTypes.oneOfType([PropTypes.object]),
  /**
   *  detach dialog out from component
   */
  detachDialog: PropTypes.bool,
};

VideoButton.defaultProps = {
  alt: '',
  title: '',
  className: '',
  buttonClassName: '',
  textClassName: '',
  text: '',
  children: <div />,
  component: '',
  buttonText: '',
  icon: <span className="icon-video" />,
  variant: 'Simple-Button',
  styleName: componentStyles.simpleButton,
  detachDialog: false,
  video: {
    videoLink: '',
    videoThumbnail: null,
    title: '',
    autoplay: false,
    transcript: '',
    componentWidth: null,
    styles: '',
  },
};

export default VideoButton;
